import { render, staticRenderFns } from "./TaskRec.vue?vue&type=template&id=72af8f6c&lang=pug&"
import script from "./TaskRec.vue?vue&type=script&lang=js&"
export * from "./TaskRec.vue?vue&type=script&lang=js&"
import style0 from "./TaskRec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports